import { InputTag } from 'mixs/base/input_mixin';
export class SelectPhase extends InputTag {
  public init() {
    super.init();
    this.watch();
  }
  public onChange(e){
    this.dispatch({value: e.target.value});
  }
}

riot.mixin('inputs.complex.select-phase', SelectPhase as riot.TagMixin)
